import classNames from '@/utils/classNames';
import ChevronRightIcon from '@bloomberg/web-icons-react/ChevronRight';
import type { DetailsHTMLAttributes, HTMLAttributes, ToggleEvent } from 'react';
import type { FCC, FCl } from 'react-fc';
import styles from './Details.module.css';

interface IDetailsProps extends DetailsHTMLAttributes<HTMLDetailsElement> {
    onOpened?: () => void;
    onClosed?: () => void;
}

/**
 * A wrapper around the HTML <details> and <summary> components to use our icon design and some state handlers
 */
export const Details: FCl<IDetailsProps> = ({ className, onOpened, onClosed, children, ...rest }) => {
    const onToggle = (evt: ToggleEvent<HTMLDetailsElement>) => {
        const isOpen = evt.currentTarget.open;
        if (isOpen && onOpened) {
            onOpened();
        }
        if (!isOpen && onClosed) {
            onClosed();
        }
    };
    return (
        <details className={classNames(className, styles.details)} onToggle={onToggle} {...rest}>
            {children}
        </details>
    );
};

export const Summary: FCC<HTMLAttributes<HTMLElement>> = ({ children, className, ...rest }) => (
    <summary className={classNames(styles.summary, className)} {...rest}>
        <ChevronRightIcon className={styles.summaryIcon} />
        <span>{children}</span>
    </summary>
);

export const Content: FCC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => {
    return (
        <div className={classNames(styles.content, className)} {...rest}>
            {children}
        </div>
    );
};
